import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-body2.scss';
import '../font.scss';

export const FontBody2: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY3 : props.color
    };

    return (
        <span className={`font font-body2 ${fontClasses(props)}`}>{props.children}</span>
    )
};

export default FontBody2;
